// import usePassword from "../hooks/usePassword";
// export default function Password() {
//   const {
//     password,
//     setPassword,
//     handleSubmit,
//     isValid,
//     firstName,
//     Button,
//     Input,
//     loading,
//   } = usePassword();
//   if (loading || !Button || !Input) {
//   return <div>Loading...</div>;
// }
//   return (
//     <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto">
//       <h2 className="text-center text-[18px] md:hidden font-medium mb-6">
//         Login
//       </h2>
//       <h2 className="text-[18px] md:text-[20px] font-medium mb-6 max-w-[350px] truncate">
//         Hi {firstName}
//       </h2>
//       <div className="relative w-full">
//         <Input
//           token="my-secret-token"
//           value={password}
//           onChange={setPassword}
//           type="password"
//           placeholder="Enter your Password"
//           className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 pr-10"
//         />
//       </div>
//       <Button
//         token="my-secret-token"
//         onClick={handleSubmit}
//         disabled={!isValid}
//         className={`mt-10 w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
//           isValid
//             ? "bg-[#CF0018] text-white"
//             : "bg-gray-300 text-[#827C7C]"
//         }`}
//       >
//         Login
//       </Button>
//     </div>
//   );
// }












import usePassword from "../hooks/usePassword";

export default function Password() {
  const {
    password,
    setPassword,
    handleSubmit,
    isValid,
    firstName,
    Button,
    Input,
    loading,
    submitting,
    
  } = usePassword();
  const authToken =
  sessionStorage.getItem("AUTH_TOKEN") || "";

  if (loading || !Button || !Input) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-10 h-10 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto">
      <h2 className="text-center text-[18px] md:hidden font-medium mb-6">
        Login
      </h2>

      <h2 className="text-[18px] md:text-[20px] font-medium mb-6 max-w-[350px] truncate">
        Hi {firstName}
      </h2>

      <div className="relative w-full">
        <Input
          token={authToken}
          value={password}
          onChange={setPassword}
          type="password"
          placeholder="Enter your Password"
          className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 pr-10"
        />
      </div>

      <Button
        token={authToken}
        onClick={handleSubmit}
        disabled={!isValid || submitting}
        className={`mt-10 w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
          isValid && !submitting
            ? "bg-[#CF0018] text-white"
            : "bg-gray-300 text-[#827C7C]"
        }`}
      >
        {submitting ? "Loading..." : "Login"}
      </Button>
    </div>
  );
}
